export default "__VITE_ASSET__QO_AWYIn__"